import { z } from 'zod';

/**
 * Contrato entre a API e o watcher de rebuild que roda na VPS.
 *
 * O site é SSG: o conteúdo do CMS só chega ao ar depois de reconstruir as
 * páginas. A API não pode fazer isso sozinha (buildar exige acesso ao
 * Docker do host, que a API deliberadamente não tem), então ela apenas
 * anuncia "há conteúdo novo" e um processo do host executa e reporta.
 */

export const siteBuildStatusSchema = z.object({
  /** Há conteúdo publicado depois do último build bem-sucedido. */
  pendente: z.boolean(),
  /** Pendente E a janela de silêncio já passou. É o sinal de "pode buildar". */
  prontoParaBuild: z.boolean(),
  segundosDesdeAlteracao: z.number().int().nullable(),
  conteudoAlteradoEm: z.string().nullable(),
  ultimaEntidade: z.string().nullable(),
  ultimoBuildEm: z.string().nullable(),
  ultimoBuildStatus: z.string().nullable(),
  ultimoBuildDetalhe: z.string().nullable(),
  quietSeconds: z.number().int(),
});

export type SiteBuildStatus = z.infer<typeof siteBuildStatusSchema>;

/**
 * Relato do watcher ao terminar um build.
 *
 * `iniciadoEm` é o instante em que o build COMEÇOU, não o de agora. Uma
 * publicação feita durante o build precisa continuar pendente depois dele
 * — se gravássemos o fim, essa edição ficaria presa até a rodada seguinte.
 */
export const siteBuildDoneSchema = z.object({
  status: z.enum(['ok', 'erro']),
  iniciadoEm: z.string().datetime({ offset: true }),
  detalhe: z.string().max(2000).nullish(),
});

export type SiteBuildDone = z.infer<typeof siteBuildDoneSchema>;
